<section id="about" class="big-section bg-gradient-top-very-light-gray pb-0 sm-pt-0">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="row align-items-center mb-6" 
             data-anime='{ "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
          <div class="col-10">
            <span class="text-base-color fw-700 text-uppercase fs-14 ls-05px">About VeeduPlan</span>
          </div>
          <!--<div class="col-2 text-end">
            <span class="text-base-color fs-14 fw-700">01</span>
          </div>-->
          <div class="col-12 mt-5px">
            <div class="separator-line-2px w-100 d-block bg-base-color"></div>
          </div>
        </div>

        <div class="row" 
             data-anime='{ "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
          <div class="col-12">
            <h4 class="fw-700 ls-minus-1px mb-20px">
              <span style="color: #c2001c;">Expertise</span> - House plan design for Residential and commercial.
            </h4>
            <p class="w-95 lg-w-110 text-align-justify fs-30">
              We have done projects around 3000+
            </p>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</section>